import * as _ from "../../../util/lodash";
import React from 'react';
import cx from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { extractElement } from "../../../util";
import { colors, icons, font, positions, shapes } from "../../../enums";
import Icon from "../icon";
import { whitelistStyles } from "../hoc";
var Lozenge = createComponent({
  displayName: 'Lozenge',
  propTypes: {
    text: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.element, // Icon only
    PropTypes.oneOf(icons.ALL), PropTypes.shape({
      content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
      position: PropTypes.oneOf(positions.LR)
    })]),
    font: PropTypes.shape({
      weight: PropTypes.oneOf(font.weights.ALL),
      family: PropTypes.oneOf(font.families.ALL),
      emphasis: PropTypes.oneOf(font.emphasis.ALL)
    }),
    color: PropTypes.oneOf(colors.ALL),
    style: PropTypes.object,
    shape: PropTypes.oneOf(_.without(shapes.ALL, shapes.CIRCULAR)),
    isCompact: PropTypes.bool
  },
  defaultProps: {
    text: null,
    icon: null,
    color: colors.ACCENT,
    style: undefined,
    font: {
      weight: font.weights.REGULAR,
      family: font.families.SYSTEM,
      emphasis: font.emphasis.CAPS
    },
    shape: shapes.ROUNDED,
    isCompact: false
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var _cx;

    var icon = extractElement(Icon, p.icon, 'name');
    var fontStyles = {
      family: p.font.family || font.families.SYSTEM,
      emphasis: p.font.emphasis || font.emphasis.CAPS,
      weight: p.font.weight || font.weights.REGULAR
    }; // Must keep .ck-lozenge rather than .ck.lozenge as there is CSS in coreapp targeting .lozenge that will cause undesired behavior

    var className = cx('ck-lozenge', p.color, (_cx = {
      inverted: p.isInverted,
      icon: !!icon,
      'icon--left': !!icon && icon.position === positions.LEFT,
      'icon--right': !!icon && icon.position === positions.RIGHT
    }, _cx["shape-" + p.shape] = true, _cx["font-" + fontStyles.family + "-" + fontStyles.weight] = true, _cx['font-caps'] = fontStyles.emphasis === font.emphasis.CAPS, _cx.compact = p.isCompact, _cx));
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: p.style
    }, /*#__PURE__*/React.createElement("div", {
      className: "lozenge__content"
    }, !!icon && icon.position === positions.LEFT && icon.element, /*#__PURE__*/React.createElement("div", {
      className: "lozenge__content__text"
    }, p.text), !!icon && icon.position === positions.RIGHT && icon.element));
  }
});
export default whitelistStyles('width')(Lozenge);
//# sourceMappingURL=index.js.map